// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-modal{
    overflow:initial;
    /* vertical-align: middle; */
    
   }
 .modal-btns button {
    padding: 10px 15px;
     /* margin: 10px 0; */
     border-radius: 25px;
     gap: 62px;
     font-weight: 600;
 }
 .facebook-img{
     background: #12b534;
     color: #fff;
     width: 370px;
     height: 45px;
     display: flex;
     justify-content: baseline;
      
 }
 .google-img{
     background: #6bc118;
     color: #fff;
     width: 370px;
     height: 45px;
     display: flex;
     justify-content: baseline;
 }
 .mail-button{
     color: #5c5a5a;
     border: 1px solid #5c5a5a ;
     width: 370px;
     height: 45px;
     display: flex;
     justify-content: baseline;
 }
 .image-modal1{
     width: 25px;
     margin-left: 50px !important;
 }
 .footer-mdl{
     color: #b9b9b9;
     font-size: 15px;
 }
 .title{
     font-weight: 600;
     color: #666262;
     font-size: 25px;
 }
 .logoimage{
     margin: auto !important;
 }
 .img-model1{
     width: 25px;
     height: 25px;
 }
 .img-model2{
     width: 25px;
     height: 27px;
 }
 .img-model3{
     width: 25px;
     height: 29px;
 }
 .img-model4{
     width: 25px;
     height: 19px;
 }
 .text-facebook{
     margin-right: 2px !important;
 }
 .fb-image{
     background: #12b534;
     color: #fff;
 }
 .get{
    font-size: 18px;
}
.get-form{
    width: 70% !important;
    border: 1px solid #ccc;
}
.get-image{
    width: 34% !important;
    /* width:70% !important */
}
.get-form1{
    display:inline !important;
    width: 70% !important;
}
@media screen and (max-width:375px) {
    .text-facebook ,.text-mail,.text-google,.text-apple{
        font-size: 12px;
    }
}
 @media screen and (max-width:475px) {
.facebook-img ,.google-img ,.mail-button {
        width: 100%;
    }
    .button-modal1{
        padding: 0px 5px 0px 5px  !important;
    }
    .modal-btns1{
        padding: 0px 10px 0px 10px  
    }
    .login-paddingl{
        padding-left: 5px !important;
    }
 }
 `, "",{"version":3,"sources":["webpack://./src/Components/header/Model.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,4BAA4B;;GAE7B;CACF;IACG,kBAAkB;KACjB,oBAAoB;KACpB,mBAAmB;KACnB,SAAS;KACT,gBAAgB;CACpB;CACA;KACI,mBAAmB;KACnB,WAAW;KACX,YAAY;KACZ,YAAY;KACZ,aAAa;KACb,yBAAyB;;CAE7B;CACA;KACI,mBAAmB;KACnB,WAAW;KACX,YAAY;KACZ,YAAY;KACZ,aAAa;KACb,yBAAyB;CAC7B;CACA;KACI,cAAc;KACd,0BAA0B;KAC1B,YAAY;KACZ,YAAY;KACZ,aAAa;KACb,yBAAyB;CAC7B;CACA;KACI,WAAW;KACX,4BAA4B;CAChC;CACA;KACI,cAAc;KACd,eAAe;CACnB;CACA;KACI,gBAAgB;KAChB,cAAc;KACd,eAAe;CACnB;CACA;KACI,uBAAuB;CAC3B;CACA;KACI,WAAW;KACX,YAAY;CAChB;CACA;KACI,WAAW;KACX,YAAY;CAChB;CACA;KACI,WAAW;KACX,YAAY;CAChB;CACA;KACI,WAAW;KACX,YAAY;CAChB;CACA;KACI,4BAA4B;CAChC;CACA;KACI,mBAAmB;KACnB,WAAW;CACf;CACA;IACG,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI;QACI,eAAe;IACnB;AACJ;CACC;AACD;QACQ,WAAW;IACf;IACA;QACI,oCAAoC;IACxC;IACA;QACI;IACJ;IACA;QACI,4BAA4B;IAChC;CACH","sourcesContent":[".image-modal{\n    overflow:initial;\n    /* vertical-align: middle; */\n    \n   }\n .modal-btns button {\n    padding: 10px 15px;\n     /* margin: 10px 0; */\n     border-radius: 25px;\n     gap: 62px;\n     font-weight: 600;\n }\n .facebook-img{\n     background: #12b534;\n     color: #fff;\n     width: 370px;\n     height: 45px;\n     display: flex;\n     justify-content: baseline;\n      \n }\n .google-img{\n     background: #6bc118;\n     color: #fff;\n     width: 370px;\n     height: 45px;\n     display: flex;\n     justify-content: baseline;\n }\n .mail-button{\n     color: #5c5a5a;\n     border: 1px solid #5c5a5a ;\n     width: 370px;\n     height: 45px;\n     display: flex;\n     justify-content: baseline;\n }\n .image-modal1{\n     width: 25px;\n     margin-left: 50px !important;\n }\n .footer-mdl{\n     color: #b9b9b9;\n     font-size: 15px;\n }\n .title{\n     font-weight: 600;\n     color: #666262;\n     font-size: 25px;\n }\n .logoimage{\n     margin: auto !important;\n }\n .img-model1{\n     width: 25px;\n     height: 25px;\n }\n .img-model2{\n     width: 25px;\n     height: 27px;\n }\n .img-model3{\n     width: 25px;\n     height: 29px;\n }\n .img-model4{\n     width: 25px;\n     height: 19px;\n }\n .text-facebook{\n     margin-right: 2px !important;\n }\n .fb-image{\n     background: #12b534;\n     color: #fff;\n }\n .get{\n    font-size: 18px;\n}\n.get-form{\n    width: 70% !important;\n    border: 1px solid #ccc;\n}\n.get-image{\n    width: 34% !important;\n    /* width:70% !important */\n}\n.get-form1{\n    display:inline !important;\n    width: 70% !important;\n}\n@media screen and (max-width:375px) {\n    .text-facebook ,.text-mail,.text-google,.text-apple{\n        font-size: 12px;\n    }\n}\n @media screen and (max-width:475px) {\n.facebook-img ,.google-img ,.mail-button {\n        width: 100%;\n    }\n    .button-modal1{\n        padding: 0px 5px 0px 5px  !important;\n    }\n    .modal-btns1{\n        padding: 0px 10px 0px 10px  \n    }\n    .login-paddingl{\n        padding-left: 5px !important;\n    }\n }\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
